/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForAzureSecurityGraph extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForAzureSecurityGraph");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForAzureSecurityGraph.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForAzureSecurityGraph>): ServiceAccountCredentialsBaseForAzureSecurityGraph {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForAzureSecurityGraph(), model);
        ServiceAccountCredentialsBaseForAzureSecurityGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForAzureSecurityGraph>): ServiceAccountCredentialsBaseForAzureSecurityGraph {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForAzureSecurityGraph.newInstance(<ServiceAccountCredentialsBaseForAzureSecurityGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForAzureSecurityGraph) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForAzureSecurityGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForAzureSecurityGraph): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForAzureSecurityGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id. This is a required field.
     */
    tenant_id: string;

    /**
     * Application Id. This is a required field.
     */
    application_id: string;

}
